export const firebaseConfig = {
  apiKey: "AIzaSyBBBvTcVxQq-rVQXujZJiVTj1f13Ah_Gqc",
  authDomain: "todos-965e2.firebaseapp.com",
  projectId: "todos-965e2",
  storageBucket: "todos-965e2.appspot.com",
  messagingSenderId: "425185782154",
  appId: "1:425185782154:web:1ae4cac09efa351c9cc073",
  measurementId: "G-HX18PYYD0P",
};
